// extracted by mini-css-extract-plugin
export default {"container":"share-client-modal_container__GraIs","sharesList":"share-client-modal_sharesList__g+Jm3"};